// @ts-check

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { QRTypingComponent } from './qr-typing-permissions-component';
import { SignOutComponent } from './signout-drivers-permissions-component';
import { WalletClientComponent } from './wallet-client-permissions-component';
//import { SecondaryDriverComponent } from './secondary-driver-permissions-component';
import { AppChatBotComponent } from './app-chat-bot-components';
import { CustomFieldsComponent } from './custom-fields-permissions-component';
import { CustomerDatabaseComponent } from './customer-database';
import { DeliveryMap } from './delivery-map';
import { HubLevelClusteringComponent } from './edit-hub-level-clustering';
import { CustomerEmailNotificationsComponent } from './email-notifications-component';
import { FlightboardAccessComponent } from './flightboard-access-component';
import { GoogleMapsAPIEnabledComponent } from './google-maps-api-enabled';
import { LocationTrackingPersistenceComponent } from './location-tracking-persistence';
import { LogoEnabledComponent } from './logo-enabled-component';
import { DriverOtpNotificationsComponent } from './otp-notifications-component';
import { RatingsEnabledComponent } from './ratings-enabled-component';
import { ReceiveAllDriverLocationUpdatesComponent } from './receive-all-driver-location-updates-component';
import { RoutePlanningEnabledComponent } from './route-planning-enabled';
import { CustomerSmsNotificationsComponent } from './sms-notifications-component';
import { TakealotIntegrationComponent } from './tdt-integration';
import { UseThirdPartyApi } from './use-third-party-apis';
import { RouteOptimizationGeometryComponent } from './route-optimization-geometry-component';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  heading: {
    margin: theme.spacing(2)
  }
}));

export function GeneralPermissionsComponent({ client }) {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
        <small>
          <b>Service Permissions</b>
        </small>
      </Typography>

      <SignOutComponent client={client} />
      <WalletClientComponent client={client} />
      <QRTypingComponent client={client} />
      <UseThirdPartyApi client={client} />
      <LogoEnabledComponent client={client} />
      <RatingsEnabledComponent client={client} />
      <ReceiveAllDriverLocationUpdatesComponent client={client} />
      <CustomFieldsComponent client={client} />
      <GoogleMapsAPIEnabledComponent client={client} />
      <DeliveryMap client={client} />
      <CustomerSmsNotificationsComponent client={client} />
      <DriverOtpNotificationsComponent client={client} />
      <CustomerEmailNotificationsComponent client={client} />
      <CustomerDatabaseComponent client={client} />
      <AppChatBotComponent client={client} />
      {/*<SecondaryDriverComponent client={client} />*/}
      <RoutePlanningEnabledComponent client={client} />
      <TakealotIntegrationComponent client={client} />
      <LocationTrackingPersistenceComponent client={client} />
      <FlightboardAccessComponent client={client} />
      <RouteOptimizationGeometryComponent client={client} />
      <HubLevelClusteringComponent client={client} />
    </div>
  );
}
